export function NotFound({ text = 'נכס זה לא נמצא' }: { text?: string }) {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: 'white',
      }}
    >
      <h1
        style={{
          direction: 'rtl',
          fontFamily: 'sans-serif',
          fontSize: '2rem',
        }}
      >
        {text}
      </h1>
    </div>
  );
}
